export function loadBankCardList() {
  return {
    type: 'LOAD_BANK_CARD_LIST',
  };
}

export function loadBankCardListCompletion(data, error) {
  return {
    type: 'LOAD_BANK_CARD_LIST_COMPLETION',
    list: (data && data.listData) || [],
    error,
  };
}

export function resetBankCardCreate() {
  return {
    type: 'RESET_BANK_CARD_CREATE',
  };
}

export function updateBankCardInfo(info) {
  return {
    type: 'UPDATE_BANK_CARD_INFO',
    info,
  };
}

export function loadBankCardInfo(cardId) {
  return {
    type: 'LOAD_BANK_CARD_INFO',
    cardId,
  };
}

export function loadBankCardInfoCompletion(cardId, data, error) {
  return {
    type: 'LOAD_BANK_CARD_INFO_COMPLETION',
    cardId,
    data,
    error,
  };
}

export function loadBankNameList() {
  return {
    type: 'LOAD_BANK_NAME_LIST',
  };
}

export function loadBankNameListCompletion(data, error) {
  return {
    type: 'LOAD_BANK_NAME_LIST_COMPLETION',
    list: (data && data.listData) || [],
    error,
  };
}

export function loadBankProvinceList() {
  return {
    type: 'LOAD_BANK_PROVINCE_LIST',
  };
}

export function loadBankProvinceListCompletion(data, error) {
  return {
    type: 'LOAD_BANK_PROVINCE_LIST_COMPLETION',
    list: (data && data.listData) || [],
    error,
  };
}

export function loadBankCityList(provinceId) {
  return {
    type: 'LOAD_BANK_CITY_LIST',
    provinceId,
  };
}

export function loadBankCityListCompletion(provinceId, data, error) {
  return {
    type: 'LOAD_BANK_CITY_LIST_COMPLETION',
    provinceId,
    list: (data && data.listData) || [],
    error,
  };
}

export function saveBankCard({
  name,
  cardId,
  cardCompany,
  provinceName,
  cityName,
  idCard,
  idCardImgFront,
  idCardImgOpposite,
  code,
}) {
  return {
    type: 'SAVE_BANK_CARD',
    name,
    cardId,
    cardCompany,
    provinceName,
    cityName,
    idCard,
    idCardImgFront,
    idCardImgOpposite,
    code,
  };
}

export function saveBankCardCompletion(data, error) {
  return {
    type: 'SAVE_BANK_CARD_COMPLETION',
    data,
    error,
  };
}

export function unBindBankCard(pwd) {
  return {
    type: 'UNBIND_BANK_CARD',
    pwd,
  };
}

export function unBindBankCardCompletion(error) {
  return {
    type: 'UNBIND_BANK_CARD_COMPLETION',
    error,
  };
}
